import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "unlock-provider-form" }
const _hoisted_2 = {
  key: 0,
  class: "unlock-api"
}
const _hoisted_3 = {
  class: "api-key-input-outer",
  id: "secretDiv"
}
const _hoisted_4 = {
  key: 0,
  id: "successMessage",
  class: "active-label"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mini_spinner = _resolveComponent("mini-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.signatureMatch == 'ok')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("fieldset", null, [
            _cache[2] || (_cache[2] = _createElementVNode("legend", { class: "api-key-label" }, "Incolla qui il codice per l'attivazione", -1)),
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                class: "api-key-input",
                name: "secret",
                type: "text",
                placeholder: "Incolla qui il codice per l'attivazione",
                id: "secret",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userSecretKey) = $event))
              }, null, 512), [
                [_vModelText, _ctx.userSecretKey]
              ])
            ]),
            (_ctx.done)
              ? (_openBlock(), _createElementBlock("label", _hoisted_4, "Attivazione completata!"))
              : (!_ctx.loading && !_ctx.done)
                ? (_openBlock(), _createElementBlock("input", {
                    key: 1,
                    class: "unlock-now-button",
                    id: "unlockButton",
                    type: "button",
                    value: "OK",
                    title: "Unlock service",
                    alt: "Unlock service",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.activate && _ctx.activate(...args))),
                    disabled: !_ctx.userSecretKey
                  }, null, 8, _hoisted_5))
                : _createCommentVNode("", true)
          ])
        ]))
      : (_ctx.signatureMatch == 'ko')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " ERRORE IMPREVISTO "))
        : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}